import { render } from "./Mb037.vue?vue&type=template&id=21245710"
import script from "./Mb037.vue?vue&type=script&lang=js"
export * from "./Mb037.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__